import {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react'

import { ConfirmModalConfig, MaxusConfirmModal } from './confirm-modal'

type ConfirmModalContextValue = {
  confirm: (config: ConfirmModalConfig) => void
}

const ConfirmModalContext = createContext<ConfirmModalContextValue | null>(null)

const ConfirmModalProvider = ({ children }: { children: ReactNode }) => {
  const [config, setConfig] = useState<ConfirmModalConfig | null>(null)

  const confirm = (next: ConfirmModalConfig) => setConfig(next)
  const close = () => setConfig(null)

  return (
    <ConfirmModalContext.Provider value={{ confirm }}>
      {children}
      {config && (
        <MaxusConfirmModal
          {...config}
          onCancel={() => {
            config.onCancel?.()
            close()
          }}
          onConfirm={() => {
            config.onConfirm()
            close()
          }}
        />
      )}
    </ConfirmModalContext.Provider>
  )
}

const useConfirmModal = () => {
  const context = useContext(ConfirmModalContext)
  if (!context) {
    throw new Error('useConfirmModal must be used within a ConfirmModalProvider')
  }
  return context
}

export { ConfirmModalProvider, useConfirmModal }
